import Vue from 'vue';

// Domain
import {
  IncomeBehaviorInFollowingYearStateManager,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/state/income-behavior-in-following-year-state-manager';
import IncomeBehaviorInFollowingYearState
  from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/state/income-behavior-in-following-year-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class IncomeBehaviorInFollowingYearVueStateManager
implements IncomeBehaviorInFollowingYearStateManager {
  // eslint-disable-next-line max-len
  private _state: IncomeBehaviorInFollowingYearState = Vue.observable<IncomeBehaviorInFollowingYearState>(new IncomeBehaviorInFollowingYearState());

  private readonly observers: Observer[] = [];

  get state(): IncomeBehaviorInFollowingYearState {
    return this._state;
  }

  set state(value: IncomeBehaviorInFollowingYearState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<IncomeBehaviorInFollowingYearState>) {
    type Keys = keyof IncomeBehaviorInFollowingYearState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
